export default "__VITE_ASSET__Bzu5Y32E__"